export default {
    'Login.title':'Welcome to SlidesOrator',
    'Login.stitle':'We recommend using awork email to easily collaborate with your team.',
    'Login.EmailText': 'Phone Number',
    'Login.captcha':'Sign In/Sign Up',
    'Login.getCode':'Send Code',
    'Login.resCode':'Resend',
    'Login.captchaPlaceholder':'Verification Code',
    'Login.EmailPlaceholder':'Email', 
    'Login.EmailError':'Email incorrect',
    'Login.codeError':'Please enter a 6-digit verification code',
    'Login.succeeded':'Login succeeded',
    'Login.sentCodeSucceeded':'Verification code sent successfully',
    'Login.registerSucceeded':'Registered successfully',
    'Login.register.placeholder':'Input password',
    'Login.register.placeholder2':'Enter password again',
    'Login.register.passErr1':'6 to 16 digit password, including uppercase and lowercase letters and numbers',
    'Login.register.passErr2':'Password inconsistency',
};


